<template>
  <div class="strategy-step">

    <div
      class="step-item"
      v-for="(step, index) in list" 
      :key="index">
      <div class="step-label" v-if="step.label">{{ step.label }}</div>
      <div :class="['step-content', step.label ? 'more' : '']">
        <div 
          class="content-item"
          v-for="(content,ind) in getContentList(step.content)" 
          :key="ind">
          {{ content }}
        </div>
      </div>

    </div>

  </div>
</template>

<script>

export default {
  props: {
    stepContent: [Array, String],
  },
  data() {
    return {};
  },
  computed: {
    list() {
      if (typeof this.stepContent === 'string') {
        return [{
          label: '',
          content: this.stepContent,
        }];
      }
      return this.stepContent;
    },

  },
  methods: {
    getContentList(str) {
      if (!str) return '';
      return str.split('\n');
    },
  },
};

</script>


<style lang="less" scoped>
.strategy-step {

.step-item {
  display: flex;
  align-items: stretch;
  
  &:first-child {
    margin-top: 0;
  }
  .step-label {
    font-size: 16px;
    color: #2F333D;
    line-height: 22px;
    font-weight: 600;
    width: 144px;
    padding: 16px;
  }
  .step-content {
    flex: 1;
    padding: 16px 16px 0 16px;
    &.more {
      border-bottom: 1px solid #E9EEF2;
      padding: 16px;
    }
  }
  .content-item {
    font-size: 14px;
    color: #2F333D;
    line-height: 24px;
    display: flex;
    &:first-child {
      margin-top: 0;
    }
    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #5F666E;
      margin-top: 10px;
      margin-right: 6px;
      flex-shrink: 0;
    }
    
  }
}
}
</style>


// WEBPACK FOOTER //
// src/pages/country/country-visa-strategy/components/strategy-form-item/strategy-step.vue